import { sagas as paymentTransactionsListSagas } from '../modules/Transactions/store/sagas'

export const sagas = [...paymentTransactionsListSagas]
